export default "__VITE_ASSET__Dm9_PP0R__"